import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

try {
  if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
    const baseUrl = (import.meta as unknown as { env?: { BASE_URL?: string } }).env?.BASE_URL || '/'
    const swUrl = baseUrl.endsWith('/') ? `${baseUrl}sw.js` : `${baseUrl}/sw.js`
    window.addEventListener('load', () => {
      navigator.serviceWorker.register(swUrl).catch(() => void 0)
    })
  }
} catch {
  void 0
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
